import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Button, Dialog, DialogContent, List, ListItem,
} from '@material-ui/core';
import { Announcement, Description, Star } from '@material-ui/icons';

import { useModal } from '../../../../hooks';

const S = {
  Button: styled(({ active, ...otherProps }) => <Button {...otherProps} />)`
    min-width: 32px;
    ${({ active, theme }) => active && css`
      color: ${theme.palette.secondary.main};
    `}
  `,
  Dialog: styled(Dialog)`
    .MuiPaper-root {
      width: 280px;
      margin: 40px;
    }
  `,
  DialogContent: styled(DialogContent)`
    padding: 0;
    :first-child {
      padding: 0;
    }
  `,
  List: styled(List)``,
  ListItem: styled(ListItem)`
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: 16px 24px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: 1rem;
    line-height: 1.5;
    text-overflow: ellipsis;
    white-space: nowrap;
    :hover {
      background-color: ${({ theme }) => theme.palette.hexToRgb(theme.palette.blueGrey[50], 0.5)};
    }
  `,
  Description: styled(Description)`
    margin-right: 1.5rem;
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: 1.5rem;
  `,
  Announcement: styled(Announcement)`
    margin-right: 1.5rem;
    color: ${({ theme }) => theme.palette.status.error.main};
    font-size: 1.5rem;
  `,
  Star: styled(Star)`
    margin-right: 1.5rem;
    color: ${({ theme }) => theme.palette.secondary.main};
    font-size: 1.5rem;
  `,
};

const NewsletterFilter = ({ active, onSelect }) => {
  const [open, openDialog, closeDialog] = useModal();

  const selectFilter = useCallback((event) => {
    closeDialog();

    onSelect(event.currentTarget.dataset.value);
  }, [closeDialog, onSelect]);

  return (
    <>
      <S.Button type="button" active={active} onClick={openDialog}>
        필터
      </S.Button>
      <S.Dialog open={open} onClose={closeDialog}>
        <S.DialogContent>
          <S.List>
            <S.ListItem data-value="all" onClick={selectFilter}>
              <S.Description />
              전체 가정통신문
            </S.ListItem>
            <S.ListItem data-value="unrecorded" onClick={selectFilter}>
              <S.Announcement />
              미응답 가정통신문
            </S.ListItem>
            <S.ListItem data-value="favorites" onClick={selectFilter}>
              <S.Star />
              즐겨찾기한 가정통신문
            </S.ListItem>
          </S.List>
        </S.DialogContent>
      </S.Dialog>
    </>
  );
};

NewsletterFilter.propTypes = {
  active: PropTypes.bool.isRequired,
  onSelect: PropTypes.func,
};

NewsletterFilter.defaultProps = {
  onSelect: () => {},
};

export default NewsletterFilter;
